module.exports = __webpack_public_path__ + "img/type2_bg_1.fb731c08.png";